import axios from 'axios'
import { config } from '../assets/config/config'

const apiUrl = config.api.url

const sendFeedbackEmail = (content) => {
	return axios.post(`${apiUrl}/v1/email`, {
    content: content
  })
}


export const emailService = {
  sendFeedbackEmail,
}